/**
 * @generated SignedSource<<75a0f63a3cbab4474776448dc3ca084a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type OfferQueryInput = {
  offerGuid: string;
};
export type OfferLandingPageQuery$variables = {
  input: OfferQueryInput;
};
export type OfferLandingPageQuery$data = {
  readonly offer: {
    readonly title: string;
    readonly imageUrl: string | null;
    readonly desktopImageUrl: string | null;
    readonly description: string | null;
    readonly guid: string;
    readonly advertiser: {
      readonly name: string | null;
      readonly imageUrl: string | null;
    } | null;
    readonly categories: ReadonlyArray<{
      readonly tag: string;
      readonly name: string;
    }>;
    readonly rewardLabel: string | null;
    readonly paysReward: boolean;
    readonly terms: string | null;
    readonly tags: ReadonlyArray<string>;
    readonly locales: ReadonlyArray<string>;
  } | null;
};
export type OfferLandingPageQuery = {
  variables: OfferLandingPageQuery$variables;
  response: OfferLandingPageQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "desktopImageUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Advertiser",
  "kind": "LinkedField",
  "name": "advertiser",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tag",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardLabel",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paysReward",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terms",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locales",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OfferLandingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Offer",
        "kind": "LinkedField",
        "name": "offer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OfferLandingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Offer",
        "kind": "LinkedField",
        "name": "offer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbb87a655cb565f73006fc9280e71904",
    "id": null,
    "metadata": {},
    "name": "OfferLandingPageQuery",
    "operationKind": "query",
    "text": "query OfferLandingPageQuery(\n  $input: OfferQueryInput!\n) {\n  offer(input: $input) {\n    title\n    imageUrl\n    desktopImageUrl\n    description\n    guid\n    advertiser {\n      name\n      imageUrl\n    }\n    categories {\n      tag\n      name\n    }\n    rewardLabel\n    paysReward\n    terms\n    tags\n    locales\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "efc960cb2e78ec7de9aab8d8547c68d0";

export default node;
